import { createAsyncThunk } from '@reduxjs/toolkit';
import type { IThunkApi } from 'redux-store/store';
import { getSettings } from 'services/settingsService/settingsService.service';

import type { IAppSettings } from './settings.store';

export const fetchSettings = createAsyncThunk<IAppSettings | null, undefined, IThunkApi>('settings/fetchSettings', async () => {
  return getSettings();
});
